/**
 * Helpers de fechas en formato latino dd/MM/yyyy para todo el admin web.
 * Acepta entradas ISO (yyyy-MM-dd, yyyy-MM-ddTHH:..) o ya en formato latino.
 * Devuelve siempre las dos representaciones que necesitamos:
 *  - latam:  dd/MM/yyyy   (lo que ve y edita el admin)
 *  - iso:    yyyy-MM-dd   (lo que se envía al backend)
 */

const isoRe = /^(\d{4})-(\d{2})-(\d{2})/;
const latamRe = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export function formatDateLatam(input: unknown): string {
  if (input === null || input === undefined || input === '') return '';
  const s = String(input).trim();
  const isoMatch = s.match(isoRe);
  if (isoMatch) {
    const [, y, m, d] = isoMatch;
    return `${d}/${m}/${y}`;
  }
  if (latamRe.test(s)) return s;
  // Fallback: try Date()
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = String(d.getFullYear());
  return `${dd}/${mm}/${yyyy}`;
}

export function parseLatamDate(input: unknown): string {
  if (input === null || input === undefined || input === '') return '';
  const s = String(input).trim();
  const m = s.match(latamRe);
  if (m) {
    const [, dd, mm, yyyy] = m;
    return `${yyyy}-${mm}-${dd}`;
  }
  if (isoRe.test(s)) return s.slice(0, 10);
  return s; // unparseable values are passed through unchanged
}

export function isValidLatamDate(input: string): boolean {
  if (!input) return true; // empty is allowed
  if (!latamRe.test(input)) return false;
  const [dd, mm, yyyy] = input.split('/').map(Number);
  if (mm < 1 || mm > 12 || dd < 1 || dd > 31 || yyyy < 1900 || yyyy > 3000) return false;
  const test = new Date(yyyy, mm - 1, dd);
  return test.getDate() === dd && test.getMonth() === mm - 1 && test.getFullYear() === yyyy;
}

/**
 * Formatea fecha+hora opcional para listados (`dd/MM/yyyy HH:mm`) si la entrada
 * tiene componente horario, o sólo fecha en otro caso.
 */
export function formatDateTimeLatam(input: unknown): string {
  if (input === null || input === undefined || input === '') return '';
  const s = String(input);
  const date = new Date(s);
  if (Number.isNaN(date.getTime())) return formatDateLatam(input);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = String(date.getFullYear());
  if (s.length <= 10) return `${dd}/${mm}/${yyyy}`;
  const hh = String(date.getHours()).padStart(2, '0');
  const mi = String(date.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
}
